import { Tabs } from "antd";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { regionActions } from "../../util/store/region/reducer";
import Factories from "./Factories";
import Pois from "./Pois";
import Sites from "./Sites";
import styles from "./style.module.scss";

export enum TabKey {
    Site = 'site',
    Factory = 'factory',
    Pois = 'pois'
}

const tabs: { [id: string]: { name: string, Component: React.FC } } = {
    [TabKey.Site]: {
        name: 'Site',
        Component: () => <Sites />,
    },
    [TabKey.Factory]: {
        name: 'Factory',
        Component: () => <Factories />,
    },
    [TabKey.Pois]: {
        name: 'POI Location',
        Component: () => <Pois />,
    }
}

interface IProps {
    getRegions(): void
}

class LocationPage extends Component<IProps> {
    constructor(props: IProps) {
        super(props);
        this.props.getRegions()
    }

    render() {
        return <div className='m-header bgPage'>
            <Tabs
                defaultActiveKey='users'
                centered
                tabBarExtraContent={{
                    left: <div className={[styles.header, 'header-page'].join(' ')}>
                        <div className='title-page'>
                            <b>Location Management</b>
                        </div>
                    </div>
                }}
                renderTabBar={(props, DefaultTabBar) => <DefaultTabBar className='h-[52px]' {...props} />}
                tabBarGutter={10}
                items={Object.keys(tabs).map(key => {
                    const { name, Component } = tabs[key];
                    return {
                        key,
                        label: name,
                        children: <Component />
                    }
                })}
            />
        </div>;
    }
}

export default connect(null, {
    getRegions: regionActions.getRegions
})(LocationPage);